import { CustomerWalletStatus } from "api/types";
import Tabs, { Tab } from "components/Tabs";
import { History } from "history";
import React, { FunctionComponent } from "react";
import { Routes } from "router";

export enum EditProfileTabNames {
  Interests = "Interests",
  UsageTypes = "UsageTypes",
  PinUpdate = "PinUpdate",
  Blockchain = "Blockchain",
  CustomerPersonalInfo = "CustomerPersonalInfo"
}

interface IProps {
  history: History;
  hideUsageTypeTab: boolean;
  walletStatus?: CustomerWalletStatus;
  hasNoInterests?: boolean;
  currentTab: EditProfileTabNames;
}

const EditProfileTabs: FunctionComponent<IProps> = ({
  history,
  hasNoInterests,
  walletStatus,
  currentTab,
  hideUsageTypeTab
}: IProps) => {
  const goToInterestsSelection = (): void =>
    history.push({
      pathname: Routes.EditInterestSelection,
      state: { walletStatus }
    });

  const goToUsageTypeSelection = (): void =>
    history.push({
      pathname: Routes.EditUsageTypeSelection,
      state: { walletStatus }
    });

  const goToPinUpdate = (): void =>
    history.push({ pathname: Routes.ChangePin, state: { walletStatus } });

  const goToBlockchainProfile = (): void =>
    history.push({
      pathname: Routes.BlockchainProfile,
      state: { walletStatus }
    });

  const goToUserProfile = (): void =>
    history.push({
      pathname: Routes.EditCustomerPersonalInfo,
      state: { walletStatus }
    });

  const tenantHasBlockchainEnabled =
    walletStatus &&
    walletStatus !== CustomerWalletStatus.BlockchainDisabledForTenant;

  return (
    <Tabs>
      {!hasNoInterests && (
        <Tab
          label="Interests"
          isActive={currentTab === EditProfileTabNames.Interests}
          onClick={goToInterestsSelection}
        />
      )}
      {!hideUsageTypeTab && (
        <Tab
          label="Med / Rec"
          isActive={currentTab === EditProfileTabNames.UsageTypes}
          onClick={goToUsageTypeSelection}
        />
      )}
      <Tab
        label="Profile"
        isActive={currentTab === EditProfileTabNames.CustomerPersonalInfo}
        onClick={goToUserProfile}
      />
      <Tab
        label="PIN"
        isActive={currentTab === EditProfileTabNames.PinUpdate}
        onClick={goToPinUpdate}
      />
      {tenantHasBlockchainEnabled && (
        <Tab
          label="Blockchain"
          isActive={currentTab === EditProfileTabNames.Blockchain}
          onClick={goToBlockchainProfile}
        />
      )}
    </Tabs>
  );
};

export default EditProfileTabs;



// WEBPACK FOOTER //
// ./src/screens/Main/edit-profile/tabs/EditProfileTabs.tsx